import React, { PureComponent } from 'react';
import ProductCard from './product-card';
import ReactPaginate from 'react-paginate';
import chunk from 'lodash/chunk';
import Scroll from 'react-scroll';
import { ProductClick, ProductImpressions, CriteoListingpage } from '../../../../actions/analytics';

class Products extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      current:0,
      totalCount:18, //products per page,
      lastLoad:0,
      delay:1000,
      productData:[]
    }

    this.handlePageClick = this.handlePageClick.bind(this);
  }


  handlePageClick = (data) => {
    let selected = data.selected;
    this.setState({current: selected});

    Scroll.scroller.scrollTo('search-products', {
      duration: 300,
      delay: 100,
      smooth: true
    });

  }


  static getDerivedStateFromProps(nextProps, prevState) {
    if(nextProps.data !== prevState.productData){
      return {
       productData:nextProps.data
      }
     }
    return null;
  }


  componentDidUpdate(prevProps, prevState){
    if(this.state.productData.length !== prevState.productData.length){
      this.trackImpression(this.state.productData);
    }
  }


  onProductClick(data){

    //tracking
    ProductClick(data);

  }

  trackImpression(productData){
    if (this.state.lastLoad >= (Date.now() - this.state.delay))return;
    this.setState({lastLoad:Date.now()});

    //Ecommerce and criteo tracking
    ProductImpressions(productData, this.props.currency);
    CriteoListingpage(productData)

  }

  render(){

    if(this.props.data.length === 0){
      return (
        <div className="products">
          <div className="row">
            <div className="columns small-12">
              <p>Oops no products matching your selection, please re-apply filters</p>
            </div>
          </div>
        </div>
      )
    }else{

      let newChuck = chunk(this.props.data, this.state.totalCount);
      let products = newChuck[this.state.current].map((product) => {
        return <ProductCard data={product} key={product.sys.id} onProductClick={this.onProductClick} />
      });




      return (
          <div className="search-products">
            <div className="row">
                {products}
            </div>

            <div className="row">
              <div className="columns small-12">

              <ReactPaginate previousLabel={<span className="fa fa fa-chevron-left"></span> }
                        nextLabel={<span className="fa fa fa-chevron-right"></span>}
                        breakLabel={<a href="">...</a>}
                        breakClassName={"break-me"}
                        pageCount={Math.ceil(this.props.data.length / this.state.totalCount)}
                        marginPagesDisplayed={1}
                        forcePage={this.state.current}
                        pageRangeDisplayed={2}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
              </div>
            </div>
          </div>
      )
    }
  }

}

export default Products;



// WEBPACK FOOTER //
// ./src/components/search/components/products/products.js